var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddFunds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_3_31368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 48C0 21.4903 21.4903 0 48 0C74.5097 0 96 21.4903 96 48C96 74.5097 74.5097 96 48 96C21.4903 96 0 74.5097 0 48Z",
    fill: "url(#paint0_linear_3_31368)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3_31368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 48C16 30.3269 30.3269 16 48 16C65.6731 16 80 30.3269 80 48C80 65.6731 65.6731 80 48 80C30.3269 80 16 65.6731 16 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 48C16.5 30.603 30.603 16.5 48 16.5C65.397 16.5 79.5 30.603 79.5 48C79.5 65.397 65.397 79.5 48 79.5C30.603 79.5 16.5 65.397 16.5 48Z",
    stroke: "#E1E4EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 42H61.2V54H60V57.6C60 57.9183 59.8736 58.2235 59.6485 58.4485C59.4235 58.6736 59.1183 58.8 58.8 58.8H37.2C36.8817 58.8 36.5765 58.6736 36.3515 58.4485C36.1264 58.2235 36 57.9183 36 57.6V38.4C36 38.0818 36.1264 37.7765 36.3515 37.5515C36.5765 37.3264 36.8817 37.2 37.2 37.2H58.8C59.1183 37.2 59.4235 37.3264 59.6485 37.5515C59.8736 37.7765 60 38.0818 60 38.4V42ZM57.6 54H50.4C48.8087 54 47.2826 53.3679 46.1574 52.2427C45.0321 51.1174 44.4 49.5913 44.4 48C44.4 46.4087 45.0321 44.8826 46.1574 43.7574C47.2826 42.6322 48.8087 42 50.4 42H57.6V39.6H38.4V56.4H57.6V54ZM58.8 51.6V44.4H50.4C49.4452 44.4 48.5295 44.7793 47.8544 45.4544C47.1793 46.1296 46.8 47.0452 46.8 48C46.8 48.9548 47.1793 49.8705 47.8544 50.5456C48.5295 51.2207 49.4452 51.6 50.4 51.6H58.8ZM50.4 46.8H54V49.2H50.4V46.8Z",
    fill: "#525866"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_3_31368",
    x: -24,
    y: -24,
    width: 144,
    height: 144,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_3_31368"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_3_31368",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3_31368",
    x: 14,
    y: 15,
    width: 68,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0392157 0 0 0 0 0.0509804 0 0 0 0 0.0784314 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_31368"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_31368",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_31368",
    x1: 48,
    y1: 0,
    x2: 48,
    y2: 96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#717784"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#717784",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFunds);
export default __webpack_public_path__ + "static/media/AddFunds.d0e26cc765d0db21f8e2e00638d071bb.svg";
export { ForwardRef as ReactComponent };